import React, { FC } from 'react';

import { Button } from '../../../../components';
import { ReactComponent as DownloadIcon } from '../../../../../assets/icons/download-alt-24.svg';
import { Text } from '../../components';
import { Typography } from '../../../../../../../components';
import styles from './header.module.scss';
import { useHeaderHook } from './header.hook';

const Header: FC = () => {
  const { t, state, handlePrint, handlePrintA4, isPrintA4Shown, handleGenerateModalOpen } = useHeaderHook();

  return (
    <header data-screen-print-hide>
      <div className={styles.header}>
        <div className={styles.headerInfo}>
          <Text variant={'h4'} bold={700} color={'invert'}>
            {state.entity}
          </Text>
          <Text variant={'body1'} color={'invert'}>
            {state.type === 'account' ? t('accountReport') : t('portfolioReport')}
          </Text>
          <Text variant={'body1'} capitalize color={'invert'}>
            {state.date}
          </Text>
        </div>
        <nav className={styles.headerAction}>
          <Button
            type={'button'}
            variant={'main'}
            size={'medium'}
            className={styles.downloadButton}
            leadingIcon={<DownloadIcon />}
            onClick={handlePrint}
          />
          {isPrintA4Shown && (
            <Button
              type={'button'}
              variant={'main'}
              size={'medium'}
              className={styles.headerPadding}
              onClick={handlePrintA4}
            >
              <Typography.Text variant={'bodyText2'}>{t('printA4')}</Typography.Text>
            </Button>
          )}
          <Button
            type={'button'}
            variant={'main'}
            size={'medium'}
            className={styles.headerPadding}
            onClick={handleGenerateModalOpen}
          >
            <Typography.Text variant={'bodyText2'}>{t('newReport')}</Typography.Text>
          </Button>
        </nav>
      </div>
    </header>
  );
};

export { Header };
